"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("@/helpers");
var _components = require("@/components");
var _validators = require("vuelidate/lib/validators");
var _vuex = require("vuex");
var _validate = require("@/utils/validate");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var mockPurchase = {
  InitialConsumption: 1,
  FinalConsumption: null,
  Price: 0,
  Active: true,
  PlanType: 1,
  AssetPlanId: null,
  DigitalAsset: null
};
var mockSales = {
  InitialConsumption: 1,
  FinalConsumption: null,
  Price: 0,
  Active: true,
  PlanType: 2,
  AssetPlanId: null,
  DigitalAsset: null
};
var _default = {
  components: {
    Card: _components.Card,
    AppInput: _components.AppInput,
    AppSelect: _components.AppSelect
  },
  props: {
    showWarning: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      idService: null,
      serviceForm: {},
      clientUser: null,
      form: {
        Name: '',
        DigitalAssetType: null,
        Description: '',
        Organization: null,
        Sla: null,
        Phone: null,
        Email: null,
        Webhook: '',
        UrlDocumentation: '',
        BusinessUnitId: null
      },
      fileLogo: null,
      fileSwagger: null,
      listRangesCost: [_objectSpread({}, mockPurchase)],
      listRangesSales: [_objectSpread({}, mockSales)],
      clientList: [],
      listBusinessUnits: []
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['listServiceTypes', 'listAllClients'])), {}, {
    logoValid: function logoValid() {
      if ((0, _validate.validURL)(this.serviceForm.Logo)) return true;
      return false;
    },
    swaggerValid: function swaggerValid() {
      if ((0, _validate.validURL)(this.serviceForm.Swagger)) return true;
      return false;
    }
  }),
  watch: {
    fileLogo: function () {
      var _fileLogo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(val && val.type)) {
                _context.next = 3;
                break;
              }
              if (!(val.type.indexOf('image/') <= -1)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", _helpers.messageHelper.error('Somente arquivos de imagens são aceitos'));
            case 3:
              this.form.Logo = val;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fileLogo(_x) {
        return _fileLogo.apply(this, arguments);
      }
      return fileLogo;
    }(),
    fileSwagger: function () {
      var _fileSwagger = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(val) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(val && val.type)) {
                _context2.next = 3;
                break;
              }
              if (!(val.type !== 'application/json')) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", _helpers.messageHelper.error('Somente arquivos JSON são aceitos'));
            case 3:
              this.form.Swagger = val;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fileSwagger(_x2) {
        return _fileSwagger.apply(this, arguments);
      }
      return fileSwagger;
    }(),
    clientUser: function clientUser(val) {
      if (val) {
        this.getBusinessUnits(val);
      } else {
        this.clientBusinessUnit = null;
      }
    }
  },
  created: function created() {
    var id = this.$route.params.id;
    if (id) {
      this.idService = id;
      this.getDetails();
    }
  },
  validations: function validations() {
    return {
      form: {
        Name: {
          required: _validators.required
        },
        DigitalAssetType: {
          required: _validators.required
        },
        Description: {
          required: _validators.required
        },
        Organization: {
          required: _validators.required
        },
        BusinessUnitId: {
          required: _validators.required
        },
        Sla: {},
        Phone: {
          required: _validators.required
        },
        Email: {
          required: _validators.required
        },
        Webhook: {},
        UrlDocumentation: {},
        Logo: {},
        Swagger: {}
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['uploadToS3', 'createService', 'updateService', 'fetchAllBusinessUnits', 'fetchDetailService', 'fetchPurchasePlan', 'createPurchasePlan', 'updatePurchasePlan', 'deletePurchasePlan', 'fetchSalesPlan', 'createSalesPlan', 'updateSalesPlan', 'deleteSalesPlan'])), {}, {
    getDetails: function () {
      var _getDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var data, dataPurchase, dataSales;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.idService) {
                _context3.next = 15;
                break;
              }
              _context3.next = 3;
              return this.fetchDetailService(this.idService);
            case 3:
              data = _context3.sent;
              if (!data) {
                _context3.next = 15;
                break;
              }
              this.serviceForm = data;
              this.joinForms();
              _context3.next = 9;
              return this.fetchPurchasePlan(this.idService);
            case 9:
              dataPurchase = _context3.sent;
              if (dataPurchase && dataPurchase.length) this.listRangesCost = dataPurchase;
              _context3.next = 13;
              return this.fetchSalesPlan(this.idService);
            case 13:
              dataSales = _context3.sent;
              if (dataSales && dataSales.length) this.listRangesSales = dataSales;
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    joinForms: function joinForms() {
      for (var _i = 0, _Object$entries = Object.entries(this.serviceForm); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 1),
          key = _Object$entries$_i[0];
        this.form[key] = this.serviceForm ? this.serviceForm[key] || null : null;
      }
      this.clientUser = this.serviceForm.Organization;
    },
    addNewLineCost: function addNewLineCost() {
      var arrayOrder = _lodash.default.orderBy(this.listRangesCost, ['FinalConsumption'], ['desc']);
      var lastRegister = arrayOrder[0];
      var valueInitital = lastRegister.FinalConsumption || 0;
      this.listRangesCost.push({
        InitialConsumption: Number(valueInitital) + 1,
        FinalConsumption: null,
        Price: 0,
        Active: true,
        PlanType: 1,
        AssetPlanId: null,
        DigitalAsset: null
      });
    },
    addNewLineSale: function addNewLineSale() {
      var arrayOrder = _lodash.default.orderBy(this.listRangesSales, ['FinalConsumption'], ['desc']);
      var lastRegister = arrayOrder[0];
      var valueInitital = lastRegister.FinalConsumption || 0;
      this.listRangesSales.push({
        InitialConsumption: Number(valueInitital) + 1,
        FinalConsumption: null,
        Price: 0,
        Active: true,
        PlanType: 2,
        AssetPlanId: null,
        DigitalAsset: null
      });
    },
    removeLineCost: function removeLineCost(index) {
      this.listRangesCost.splice(index, 1);
    },
    removeLineSales: function removeLineSales(index) {
      this.listRangesSales.splice(index, 1);
    },
    addNewTypeService: function addNewTypeService() {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalFormNewTypeService,
        hasModalCard: true,
        customClass: 'modal-form-new-type-service-component',
        trapFocus: true,
        canCancel: ['escape', 'outside']
      });
    },
    uploadFiles: function () {
      var _uploadFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(file, type) {
        var self;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              self = this;
              return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve, reject) {
                  var data, resp;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        data = {
                          image: file,
                          typeFile: type || ''
                        };
                        _context4.next = 3;
                        return self.uploadToS3(data);
                      case 3:
                        resp = _context4.sent;
                        if (resp) resolve(resp);else reject();
                      case 5:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x5, _x6) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function uploadFiles(_x3, _x4) {
        return _uploadFiles.apply(this, arguments);
      }
      return uploadFiles;
    }(),
    checkForm: function () {
      var _checkForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
        var _this = this;
        var payload, urlFileImageLogo, urlFileImageSwagger, operation, message, listRangesCost, listRangesCostUpdate, listRangesSales, listRangesSalesUpdate, promisseCost, promisseSales, data, promisseCostUpdate, promisseSalesUpdate;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              e.preventDefault();
              this.$v.$touch();
              if (!this.$v.$invalid) {
                _context8.next = 6;
                break;
              }
              this.$buefy.toast.open({
                duration: 5000,
                message: "Por favor, verifique os campos <b>obrigat\xF3rios</b>!",
                position: 'is-top',
                type: 'is-danger'
              });
              _context8.next = 53;
              break;
            case 6:
              payload = this.form;
              if (!this.fileLogo) {
                _context8.next = 12;
                break;
              }
              _context8.next = 10;
              return this.uploadFiles(this.fileLogo, 'zip');
            case 10:
              urlFileImageLogo = _context8.sent;
              if (urlFileImageLogo) payload.Logo = urlFileImageLogo;
            case 12:
              if (!this.fileSwagger) {
                _context8.next = 17;
                break;
              }
              _context8.next = 15;
              return this.uploadFiles(this.fileSwagger, 'json');
            case 15:
              urlFileImageSwagger = _context8.sent;
              if (urlFileImageSwagger) payload.Swagger = urlFileImageSwagger;
            case 17:
              operation = this.createService;
              message = 'Serviço cadastrado com sucesso!';
              listRangesCost = [];
              listRangesCostUpdate = [];
              listRangesSales = [];
              listRangesSalesUpdate = [];
              if (!this.idService) {
                _context8.next = 33;
                break;
              }
              operation = this.updateService;
              message = 'Serviço alterado com sucesso!';
              payload.idService = this.idService;
              promisseCost = this.listRangesCost.map(function (i) {
                var item = i;
                item.DigitalAsset = _this.idService;
                item.InitialConsumption = Number(item.InitialConsumption);
                item.FinalConsumption = Number(item.FinalConsumption);
                if (item.InitialConsumption && item.FinalConsumption) {
                  if (item.AssetPlanId) {
                    listRangesCostUpdate.push(item);
                  } else {
                    delete item.AssetPlanId;
                    listRangesCost.push(item);
                  }
                }
                return item;
              });
              _context8.next = 30;
              return Promise.all(promisseCost);
            case 30:
              promisseSales = this.listRangesSales.map(function (i) {
                var item = i;
                item.DigitalAsset = _this.idService;
                item.InitialConsumption = Number(item.InitialConsumption);
                item.FinalConsumption = Number(item.FinalConsumption);
                if (item.InitialConsumption && item.FinalConsumption) {
                  if (item.AssetPlanId) {
                    listRangesSalesUpdate.push(item);
                  } else {
                    delete item.AssetPlanId;
                    listRangesSales.push(item);
                  }
                }
                return item;
              });
              _context8.next = 33;
              return Promise.all(promisseSales);
            case 33:
              _context8.next = 35;
              return operation(payload);
            case 35:
              data = _context8.sent;
              if (!data) {
                _context8.next = 53;
                break;
              }
              if (!listRangesCost.length) {
                _context8.next = 40;
                break;
              }
              _context8.next = 40;
              return this.createPurchasePlan(listRangesCost);
            case 40:
              if (!listRangesSales.length) {
                _context8.next = 43;
                break;
              }
              _context8.next = 43;
              return this.createSalesPlan(listRangesSales);
            case 43:
              if (!listRangesCostUpdate.length) {
                _context8.next = 47;
                break;
              }
              promisseCostUpdate = listRangesCostUpdate.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(i) {
                  var item, assetPlanId;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        item = i;
                        assetPlanId = item.AssetPlanId;
                        delete item.AssetPlanId;
                        _context6.next = 5;
                        return _this.updatePurchasePlan({
                          payload: item,
                          assetPlanId: assetPlanId
                        });
                      case 5:
                        return _context6.abrupt("return", item);
                      case 6:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x8) {
                  return _ref2.apply(this, arguments);
                };
              }());
              _context8.next = 47;
              return Promise.all(promisseCostUpdate);
            case 47:
              if (!listRangesSalesUpdate.length) {
                _context8.next = 51;
                break;
              }
              promisseSalesUpdate = listRangesSalesUpdate.map( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(i) {
                  var item, assetPlanId;
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        item = i;
                        assetPlanId = item.AssetPlanId;
                        delete item.AssetPlanId;
                        _context7.next = 5;
                        return _this.updateSalesPlan({
                          payload: item,
                          assetPlanId: assetPlanId
                        });
                      case 5:
                        return _context7.abrupt("return", item);
                      case 6:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x9) {
                  return _ref3.apply(this, arguments);
                };
              }());
              _context8.next = 51;
              return Promise.all(promisseSalesUpdate);
            case 51:
              this.$buefy.toast.open({
                message: message,
                type: 'is-success',
                duration: 5000
              });
              this.$emit('update:showWarning', true);
            case 53:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function checkForm(_x7) {
        return _checkForm.apply(this, arguments);
      }
      return checkForm;
    }(),
    confirmDelete: function confirmDelete(type, item, idx) {
      var action = this.deletePurchase;
      if (type === 'sales') action = this.deletePurchase;
      if (item.AssetPlanId) {
        this.$buefy.modal.open({
          parent: this,
          component: _components.ModalWarning,
          hasModalCard: true,
          trapFocus: true,
          props: {
            text: 'Deseja realmente exluir',
            action: action,
            name: 'esse item',
            idItem: item.AssetPlanId,
            idSecond: idx
          }
        });
      } else {
        if (type === 'cost') this.removeLineCost(idx);else this.removeLineSales(idx);
      }
    },
    deletePurchase: function () {
      var _deletePurchase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(id, index) {
        var data;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.deletePurchasePlan(id);
            case 2:
              data = _context9.sent;
              if (data) {
                this.removeLineCost(index);
                this.getDetails();
              }
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function deletePurchase(_x10, _x11) {
        return _deletePurchase.apply(this, arguments);
      }
      return deletePurchase;
    }(),
    deleteSales: function () {
      var _deleteSales = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(id, index) {
        var data;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.deleteBusinessUnits(id);
            case 2:
              data = _context10.sent;
              if (data) {
                this.removeLineSales(index);
                this.getDetails();
              }
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function deleteSales(_x12, _x13) {
        return _deleteSales.apply(this, arguments);
      }
      return deleteSales;
    }(),
    getBusinessUnits: function () {
      var _getBusinessUnits = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(id) {
        var data;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.form.Organization = id;
              _context11.next = 3;
              return this.fetchAllBusinessUnits(id);
            case 3:
              data = _context11.sent;
              if (data) {
                this.listBusinessUnits = data;
              }
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getBusinessUnits(_x14) {
        return _getBusinessUnits.apply(this, arguments);
      }
      return getBusinessUnits;
    }()
  })
};
exports.default = _default;